/**
 * Telemetry Exports
 *
 * Central export point for telemetry utilities.
 *
 * @packageDocumentation
 */

export type {
  Span,
  SpanAttributes,
  SpanStatus,
  TraceContext,
} from './tracer';

export {
  createSpan,
  endSpan,
  addChildSpan,
  setSpanAttribute,
  generateTraceId,
  generateSpanId,
  createTraceContext,
  formatTraceparent,
  parseTraceparent,
  flattenSpans,
  totalDuration,
  countSpans,
} from './tracer';
